import React, { Fragment } from 'react';
import './home.css';

import topImage from '../../../img/Home/editor-still.png';
import jpMorganLogo from '../../../img/JP-Morgan-Chase.png';
import newableLogo from '../../../img/Newable.png';
import ubsLogo from '../../../img/UBS.png';

import Hero from './Hero';
import SectionIntro from './SectionIntro';
import Panels from './Panels';
import DualCard from './DualCard';

const HomePage = () => {
  return (
    <Fragment>
      <div>
       <Hero />
      </div>

      <div className="mt-6">
        <SectionIntro
          // title={<>Lorem ipsum dolor sit amet,<br />consectetur adipiscing elit.</>}
          title={<>Our brains crave a good story.<br /> We help you invent it.</>}
          body={<>People use narratives to understand the world. <br /> Now, the same process expert writers use <br /> becomes as easy as a click, a drag, and a drop.</>}
        />

        <section className="supporters" aria-label="Supported by">
          <p className="supporters-label">Supported by:</p>
          <div className="supporters-logos">
            <img
              className="supporter-logo supporter-logo--jpmorgan"
              src={jpMorganLogo}
              alt="J.P. Morgan"
            />
            <img
              className="supporter-logo supporter-logo--newable"
              src={newableLogo}
              alt="Newable"
            />
            <img
              className="supporter-logo supporter-logo--ubs"
              src={ubsLogo}
              alt="UBS"
            />
          </div>
        </section>

        <div className="mt-10 mb-16">
          <div className="home-container">
            <div className="image-wrapper rounded-sm">
              <img
                className="top-image-style outline outline-offset-2 outline-2 outline-zinc-300"
                decoding="async"
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 75vw, 70vw"
                srcSet={`
                  ${topImage}?w=400 400w,
                  ${topImage}?w=800 800w,
                  ${topImage}?w=1200 1200w,
                  ${topImage} 1600w
                `}
                src={topImage}
                alt="WriterAssist editor"
              />
            </div>
          </div>
        </div>

        {/* <h2 className="sd-panels-title">A great story in four steps</h2> */}

        <Panels />
        <DualCard />
      </div>
    </Fragment>
  );
};

export default HomePage;
